// extracted by mini-css-extract-plugin
export default {"dateInput":"PersonalInformationForm_dateInput__SGO8e"};